import { Document, StyleSheet, View } from '@react-pdf/renderer';
import { StatementData } from '../modal/PortfolioStatementModal';
import PortfolioStatementDisclaimer from './PortfolioStatementDisclaimer';
import PortfolioStatementHeader from './PortfolioStatementHeader';
import PortfolioStatementLayout from './PortfolioStatementLayout';
import PortfolioStatementPositionsHeader from './PortfolioStatementPositionsHeader';
import PortfolioStatementPositionsTable from './PortfolioStatementPositionsTable';

export interface PortfolioStatementProps extends StatementData {}

const styles = StyleSheet.create({
    block: {
        marginTop: 24
    }
});

const PortfolioStatement = (data: PortfolioStatementProps) => {
    const { metadata } = data;
    return (
        <Document title="Client Statement" subject={`Client statement for ${metadata.entity} - ${metadata.account}`}>
            <PortfolioStatementLayout label="Client statement">
                <PortfolioStatementHeader {...data} />
                <View style={styles.block}>
                    <PortfolioStatementPositionsHeader eyebrow="POSITIONS" title="Client Portfolio" />
                    <PortfolioStatementPositionsTable {...data} />
                </View>
            </PortfolioStatementLayout>

            <PortfolioStatementLayout label="Disclaimer">
                <PortfolioStatementDisclaimer />
            </PortfolioStatementLayout>
        </Document>
    );
};

export default PortfolioStatement;
